import { render, staticRenderFns } from "./ElevatorSafetyCheck.vue?vue&type=template&id=5c8bba13&scoped=true&"
import script from "./ElevatorSafetyCheck.vue?vue&type=script&lang=js&"
export * from "./ElevatorSafetyCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8bba13",
  null
  
)

export default component.exports